/**
 * Review
 * Todo:
 * Очень много неиспользуемых импортов
 */
import {
  Component, OnInit, OnDestroy, style, keyframes, animate, state, transition, trigger,
  ViewContainerRef
} from '@angular/core';
import {DataService} from "../services/data.service";
import {LoginService} from "../services/login.service";
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/operator/delay';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import 'material-design-lite/material.min.js'
import {EditDataService, Info} from "../services/edit-data.service";

@Component({
  selector: 'app-order',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
  providers: [ToastsManager],

})

export class paymentSuccess implements OnInit, OnDestroy {
  public data: any = {};
  public datapayment: any = {};
  public paymentStatus: string = '';
  public prolongationStatus: string = '';
  public summaProlong: string = '';
  public dateToProlong: string = '';
  public statusMessage: string = '';
  public showFallback: boolean = true;


  paymentSettings:any;
  private statusPoll: any;
  private statusPollAttempts: number = 0;
  private readonly maxStatusPollAttempts: number = 15;


  constructor(private idle: Idle, public router: Router, private dataService: DataService,
              public editDataService: EditDataService,  public toastr: ToastsManager,
              public loginService: LoginService, vRef: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vRef);

  }

  ngOnInit() {
    this.editDataService.getData().subscribe(data => this.data = data);
    let statusToken = localStorage.getItem('paymentStatusToken');

    if (!statusToken) {
      return;
    }

    this.showFallback = false;
    this.statusMessage = 'Перевіряємо статус оплати. Будь ласка, зачекайте.';
    this.checkPaymentStatus(statusToken);
    this.statusPoll = setInterval(() => this.checkPaymentStatus(statusToken), 2000);
  }

  ngOnDestroy() {
    this.stopStatusPolling();
  }

  private checkPaymentStatus(statusToken: string) {
    if (this.statusPollAttempts >= this.maxStatusPollAttempts) {
      this.stopStatusPolling();
      return;
    }

    this.statusPollAttempts += 1;
    this.dataService.getPaymentStatus(statusToken).subscribe(
      status => {
        this.paymentStatus = status.paymentStatus;
        this.prolongationStatus = status.prolongationStatus;

        if (this.prolongationStatus === 'completed') {
          this.summaProlong = Number(status.summaProlong).toFixed(2).replace('.', ',');
          this.dateToProlong = status.dateToProlong;
          this.stopStatusPolling();
        } else if (this.prolongationStatus === 'processing') {
          this.statusMessage = 'Оплату підтверджено. Завершуємо продовження строку користування кредитом.';
        } else {
          this.statusMessage = 'Перевіряємо статус оплати. Будь ласка, зачекайте.';
        }
      },
      () => {
        this.stopStatusPolling();
        this.showFallback = true;
      }
    );
  }

  private stopStatusPolling() {
    if (this.statusPoll) {
      clearInterval(this.statusPoll);
      this.statusPoll = null;
    }
  }


  /**
   * Review
   * Todo:
   * Можно заменить на logout = this.loginService.logout;
   */
  logout() {
    localStorage.removeItem('paymentStatusToken');
    this.loginService.logout();


  }


}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/payment/paymentSuccess.component.ts